import { render, staticRenderFns } from "./RelacaoFinanceira.vue?vue&type=template&id=1f934fac"
import script from "./RelacaoFinanceira.vue?vue&type=script&lang=js"
export * from "./RelacaoFinanceira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports